import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-cart-subtotal',
  templateUrl: './cart-subtotal.component.html',
  styleUrls: ['./cart-subtotal.component.scss']
})
export class CartSubtotalComponent {
  @Input() subtotal;
  constructor() {}
}



// WEBPACK FOOTER //
// /Users/iangoldfarb/Desktop/SupplyHub/shFrontEnd/src/app/navbar/shopping-cart/cart-subtotal/cart-subtotal.component.ts